<template>
  <div class="edit_bylaw">
    <div class="form-group">
      <v-select
          :items="kindByLaw"
          v-model="byLaw.kindByLaw"
          :placeholder="byLaw.kindByLaw.transName"
          @change="selectedKindByLaw($event)"
          :label="$t('Вид подзаконного акта')"
          item-text="transName"
          required
          outlined
          return-object
      />
    </div>
    
    <div class="form-group">
      <v-text-field
        v-model="byLaw.nameKg"
        :label="$t('Наименование на гос.языке')"
        required
        outlined
      />
    </div>
    <div class="form-group">
      <v-text-field
          v-model="byLaw.name"
          :label="$t('Наименование на оф.языке')"
          required
          outlined
      />
    </div>
    <div class="form-group">
      <v-text-field
        v-model="byLaw.number"
        type="number"
        :label="$t('Номер')"
        required
        outlined
      />
    </div>

    <!------->
    <div
      class="edit_bylaw-date"
    >
      <div class="edit_bylaw-date-label">
        Дата принятия
      </div>
      <div class="form-date">
        <v-menu
          v-model="formImpDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="byLaw.adoptionDate"
              required
              readonly
              v-on="on"
              outlined
              rounded
              dense
            />
          </template>
          <v-date-picker
            v-model="byLaw.adoptionDate"
            @input="formImpDateMenu = false"
            :weekday-format="getDay"
            :month-format="getMonthFormat"
            :header-date-format="getHeaderDateFormat"
            no-title
            first-day-of-week="1"
          />
        </v-menu>
      </div>
    </div>
    <!------->
    <div class="form-group">
      <v-text-field
        v-model="byLaw.zbdCode"
        type="number"
        :label="$t('Код документа в ЦБД')"
        required
        outlined
      />
    </div>
    <v-row>
      <v-col cols="12" md="12">
        <v-btn @click="save" small outlined color="primary">
          {{ $t('Сохранить') }}
        </v-btn>
        <v-btn @click="cancel" class="ml-2" small outlined>
          {{ $t('Отмена') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import fieldInfo from '@/components/app/fieldInfo'
import mixin from '@/plugins/mixin/mixin'

export default {
  name: 'InlineEditByLaw',
  inject: ['kindByLaw'],
  components: {
    fieldInfo
  },
  mixins: [mixin],
  props: {
    byLaw: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      formImpDateMenu: false
    }
  },
 
  methods: {
    selectedKindByLaw (value) {
 
    },
    save () {
      this.byLaw.kindByLaw = this.byLaw.kindByLaw.id
      this.$emit('save', this.byLaw)
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss">
  .edit_bylaw {
    max-width: 400px;
    .v-input {
      padding-top: 10px;
    }
    
    &-date {
      .form-date {
        .v-input {
          max-width: 400px;
          padding: 10px 1px;
        }
      }
    }
  }
</style>